import { Transformation, Calculated, GovernanceType } from '@global/types'
import { t } from '@lingui/core/macro'
import { ListGovernance, ValidationValue } from 'dataContainer/validators/validationTypes'

interface Field {
  transformation?: Transformation
  name: string
  list_governance?: ListGovernance
  governance_type: GovernanceType
}

type ListTypes = 'drill-down' | 'dependent' | 'dropdown'
interface TemplateField {
  field?: Field
  name: string
  id: number
  governance_type?: GovernanceType
}

export function templateFieldHasCalculated(templateField: TemplateField): boolean {
  return Boolean(templateField.field?.transformation?.calculated?.length)
}

export function validateReference(templateField: TemplateField, fieldsById: Record<number, Field>) {
  const sourceFieldId = getCalculatedFromTemplateField(templateField)?.origin_field_id

  if (sourceFieldId && !fieldsById[sourceFieldId]) {
    const name = templateField.field?.name ?? ''
    return {
      type: 'ERROR',
      message: t`${name} is referencing a calculated field that does not exist in this template.`,
      reference: {
        step: 'govern',
        id: `SCHEMA_ITEM_${String(templateField.id)}`,
        fieldId: templateField.id,
      },
    }
  }

  return null
}

export function getCalculatedFromTemplateField(
  templateField: TemplateField,
): Calculated | undefined {
  // While calculated fields are currently an array, there is only support for one right now.
  return templateField.field?.transformation?.calculated?.[0]
}

export function isTemplateFieldListOfType(templateField: TemplateField, type: ListTypes): boolean {
  return templateField.field?.list_governance?.lists.type === type
}

export function isGovernanceType(templateField: TemplateField, type: GovernanceType): boolean {
  return templateField.governance_type === type
}

export function isFieldGovernanceType(
  templateField: TemplateField | undefined | null,
  type: GovernanceType,
): boolean {
  return templateField?.field?.governance_type === type
}

export function hasValidOptions(valueObj: ValidationValue): boolean {
  return !!valueObj.metadata?.validOptions?.length
}

/**
 * Helper function to get the origin_field_id in a more reliable way.
 * @param {Field} fieldsetField
 * @returns {Number | null} - ID of possible "child" field
 */
export function getCalculatedOriginFieldId(fieldsetField: Field): number | null {
  const calculatedTransform = fieldsetField.transformation?.calculated
  if (calculatedTransform?.[0]) {
    return calculatedTransform[0].origin_field_id
  }

  return null
}
